import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllUsers } from "../Home/getAllUsers";
import { prefetchTransactions } from "../utils/fetchTxn";
import { useAuth } from "../../context/AuthContext";
import "./Community.css";

const CommunityPage = () => {
    const [users, setUsers] = useState([]);
    const navigate = useNavigate();
    const { userId } = useAuth();

    useEffect(() => {
        getAllUsers(setUsers);
    }, []);

    return (
        <div className="community-page">
            <h2>Community</h2>

            <div className="community-grid">
                {users.map(u => (
                    <div
                        key={u.id}
                        className="user-card"
                        onMouseEnter={() =>
                            prefetchTransactions(
                                u.id,
                                userId
                            )
                        }
                        onClick={() =>
                            navigate(`/community/${u.username}`)
                        }
                    >
                        {u.username}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CommunityPage;